export default __webpack_public_path__ + "static/media/SwamijiNew4.7948e547.JPG";